export default __webpack_public_path__ + "static/media/eye.4795c684.svg";